
import React, { Component } from 'react'
import { connect } from 'react-redux'
import Draggable from 'react-draggable'

import MicroSpinner from './MicroSpinner'

import { uiHelper } from '../helpers'
import { getAllPendingDocs, startUpload, endUpload } from '../actions'
import { envConstants } from '../constants'

const initialState = {
  showUpload: true
}

class Uploader extends Component {
  constructor () {
    super()
    this.state = initialState
  }

  componentDidMount () {
    this.props.getAllPendingDocs()
  }

  componentDidUpdate () {
    const { queue, uploading } = this.props.upload
    if ((queue || []).length > 0) {
      const doc = queue[0]
      if (!uploading) {
        this.props.startUpload(doc)
      }
    }
  }

  render () {
    const { queue, uploading } = this.props.upload
    if ((queue || []).length === 0) {
      return <></>
    } else {
      return (
        <Draggable>
          <div className="uploader-container">
            <ul className="uploader-counter">
              <li>
                {queue.length} file
                {
                  uploading && (
                    <MicroSpinner />
                  )
                }
              </li>
              <li>{uiHelper.byteToMega(queue.reduce((a, b) => a + (b.size || 0), 0) - queue.reduce((a, b) => a + (b.sent || 0), 0))}</li>
            </ul>
            <ul className="uploader-queue">
              {
                (queue || []).sort((a, b) => (a.sent < b.sent) ? 1 : -1).map((f, index) => {
                  const sent = f.chunks.filter(x => x.status === envConstants.upload.sent).reduce((a, b) => a + (b.size || 0), 0)
                  return (
                    <li key={index}>
                      <ul className="uploader-item">
                        <li className="name">{f.name}</li>
                        <li className="sent">{uiHelper.byteToMega(sent)}</li>
                        <li className="progress"><span className="bar"><span className="done" style={{ width: uiHelper.percentage(f.size, sent) + 'px' }}></span></span></li>
                        <li className="size">{uiHelper.byteToMega(f.size)}</li>
                      </ul>
                    </li>
                  )
                })
              }
            </ul>
          </div>
        </Draggable>
      )
    }
  }
}

function mapStateToProps (state) {
  return state
}

export default connect(mapStateToProps, { getAllPendingDocs, startUpload, endUpload })(Uploader)
